import { useAllMatches } from '../../hooks/matchHooks/useMatchData';
import { useParams } from 'react-router-dom';
import clubInfo from "../../static/clubInfo";
import HeaderBannerContent from './components/HeaderBannerContent/HeaderBannerContent';
import { useIsMatchFinished } from '../../hooks/useIsMatchFinished';
import { useSingleMatchData } from '../../hooks/matchHooks/useSingleMatchData';
import './MatchPage.css'


export default function MatchPage() {
  const { matchId } = useParams();
  const { data: matches, isLoading } = useAllMatches();
  const match = matches ? matches.find(m => m.id.toString() === matchId) : null;
  const isMatchFinished = useIsMatchFinished(match);
  const { data: matchInfo, isLoading: isMatchLoading } = useSingleMatchData(matchId);
  if (isLoading) {
    return <div className="header-banner">Lade...</div>;
  }


  return (
    <div className="match-page">
      <div className="header-banner">
       <HeaderBannerContent match={match} isMatchFinished={isMatchFinished} clubInfo={clubInfo}/>
      </div>
      <div className="match-page__content">
        <h2>Spielinfo ist in Arbeit.</h2>
      </div>
    </div>
  )
}
